export default __webpack_public_path__ + "static/media/magenta2.5b9cca09.png";